<template>
    <div v-if="show()" class="alert alert-warning" style="max-width: 1170px;
    width: 95%;
    margin: 0 auto;">
      <i aria-hidden="true" class="fa fa-exclamation"></i>
      <p v-if="days() === 0">Your account has been temporarily suspended. You cannot take new orders today.</p>
      <p v-else>Your account has been temporarily suspended.<br> You cannot take new orders for {{ days() }} {{ days() === 1 ? 'day' : 'days' }} from now.</p>
<!--      <p v-if="days() <= 1">Your account has been temporarily suspended. You cannot take new orders for {{ days() }} day from now.</p>-->
    </div>


</template>


<script>
import moment from "moment";

    export default {
        data() {
            return {

                user: window.user,

            }
        },

      methods: {
        show(){
          return moment() < moment(this.user.profile.banned_until);
        },

        days() {
          let days = moment().diff(moment(this.user.profile.banned_until), 'days');
          return Math.abs(days);
        }
      },

    }
</script>